import * as React from 'react';
import dynamic from 'next/dynamic';
import { GrammarLandingPageLayout } from '@doltech/domains/landing-grammar/lib/landing/GrammarLandingPageLayout';
import { GrammarTemplateTypeEnum } from '@doltech/domains/landing-grammar/lib/shared/constants';
import PageNotFound from '../pages/404';

const LandingGrammarTemplatePage = dynamic(
  () => import('../templates/LandingGrammarTemplatePage'),
  { loading: () => <GrammarLandingPageLayout loading/> },
);

export const PageTemplate = (props) => {
  const { pageType, pageProps } = props;
  switch (pageType) {
    case GrammarTemplateTypeEnum.LANDING_HOME:
    case GrammarTemplateTypeEnum.LANDING_GRAMMAR_THEORY:
    case GrammarTemplateTypeEnum.LANDING_GRAMMAR_EXERCISE:
    case GrammarTemplateTypeEnum.BLOG_GRAMMAR_THEORY:
    case GrammarTemplateTypeEnum.BLOG_GRAMMAR_EXERCISE: {
      return (
        <GrammarLandingPageLayout {...props} hasPromotion>
          <LandingGrammarTemplatePage {...pageProps} {...props} />
        </GrammarLandingPageLayout>
      );
    }
    case GrammarTemplateTypeEnum.BLOG_GRAMMAR_AUTHOR: {
      return (
        <GrammarLandingPageLayout {...props}>
          <LandingGrammarTemplatePage {...pageProps} {...props} />
        </GrammarLandingPageLayout>
      );
    }
    default: {
      return (
        <PageNotFound/>
      );
    }
  }
};
